import { z } from 'zod'

export const notificationFormSchema = z.object({
  notification_type: z.string().min(1, 'Notification type is required'),
  roles: z.array(z.string()).min(1, 'At least one role is required'),
})

export type NotificationFormValues = z.infer<typeof notificationFormSchema>
